module.exports = __webpack_public_path__ + "assets/autotest2.jpg?a46f30037539b1eab6fce1b50bdb8bc5";